import { useEffect, useRef } from "react";
import { useLogout } from "../Use-auth";
import { useLocation } from "wouter";
import { socket } from "../../lib/socket";
import { encryptData, decryptData } from "../../lib/crypto";

export default function ForceLogoutChecker() {
    const { mutate: logout } = useLogout();
    const [, setLocation] = useLocation();

    useEffect(() => {
        const encrypted = localStorage.getItem("auth_user");
        const auth = encrypted ? decryptData(encrypted) : null;
        
        if (!auth?.userId) return;

        if (!socket.connected) {
            socket.connect();
        }

        socket.on("connect", () => {
            socket.emit("join", auth.userId);
        });

        const handleForceLogout = () => {

            logout();

            localStorage.removeItem("auth_user");

            setTimeout(() => {
                setLocation("/login");
            }, 200);
        };

        socket.on("force_logout", handleForceLogout);

        return () => {
            socket.off("force_logout", handleForceLogout);
            socket.off("connect");
        };
    }, []);

    return null;
}